import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5 7.156c0-.355.273-.656.656-.656h3.282c.464 0 .93.246 1.203.629l2.98 3.883q.083.082.164.082h3.473l-1.067-1.067a.6.6 0 0 1 0-.902c.246-.273.657-.273.93 0l2.188 2.188a.644.644 0 0 1 0 .902l-2.188 2.187c-.273.274-.683.274-.93 0a.6.6 0 0 1 0-.902l1.067-1.066h-3.473c-.055 0-.137.027-.164.082l-2.98 3.882A1.49 1.49 0 0 1 8.938 17H5.656A.63.63 0 0 1 5 16.344c0-.356.273-.657.656-.657h3.282c.054 0 .136-.027.164-.082l2.925-3.855-2.925-3.828c-.028-.055-.11-.11-.165-.11H5.656A.63.63 0 0 1 5 7.157"
    }, null, -1)
  ]))]))
}
export default { render: render }